// extracted by mini-css-extract-plugin
module.exports = {"slider-column":"QuoteSliderModule_slider-column__lesFW"};